module.exports = __webpack_public_path__ + "media/cover.f056a4cb.mp4";